
import { createAction, props } from '@ngrx/store';
import { UploadActionProps } from '../../guards/resolver.helper';
import { GatewayResponseErrorType } from '../../services/app-gateway.service';
import { TextTemplateEntity } from '../../entities/text-template.entity';
import { TextTemplateAddRequest, TextTemplateDeleteRequest, TextTemplateEditRequest } from '@dave/types';




const prefix = 'data/' + 'textTemplate/';
export const TextTemplateActionTypes = {
    Load: createAction(prefix + 'load', props< UploadActionProps >()),
    Change: createAction(prefix + 'change', props<{ Payload: TextTemplateEditRequest }>()),
    Delete: createAction(prefix + 'delete', props<{ Payload: TextTemplateDeleteRequest }>()),


    UpdateAll: createAction(prefix + 'updateAll', props<{ Payload: Array<TextTemplateEntity>; updateLatestUpdatedAt?: boolean }>()),
    UpdateMany: createAction(prefix + 'updateMany', props<{ Payload: Array<TextTemplateEntity>; updateLatestUpdatedAt?: boolean }>()),
    UpdateOne: createAction(prefix + 'updateOne', props<{ Payload: TextTemplateEntity }>()),
    RemoveOne: createAction(prefix + 'remove', props<{ Payload: number }>()),

    CreateRequest: createAction(prefix + 'create/request', props<{ Payload: TextTemplateAddRequest }>()),
    CreateSuccess: createAction(prefix + 'create/success', props<{ Payload: TextTemplateEntity }>()),
    CreateFailure: createAction(prefix + 'create/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),
};
